var React = require('react');

function ClockLight (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M240 112C240 103.2 247.2 96 256 96C264.8 96 272 103.2 272 112V247.4L360.9 306.7C368.2 311.6 370.2 321.5 365.3 328.9C360.4 336.2 350.5 338.2 343.1 333.3L247.1 269.3C242.7 266.3 239.1 261.3 239.1 256L240 112zM256 0C397.4 0 512 114.6 512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0zM32 256C32 379.7 132.3 480 256 480C379.7 480 480 379.7 480 256C480 132.3 379.7 32 256 32C132.3 32 32 132.3 32 256z"}));
}

ClockLight.defaultProps = {"viewBox":"0 0 512 512"};

module.exports = ClockLight;

ClockLight.default = ClockLight;
